import { ICONS, IconType } from '@aksia/infrastructure';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  OnInit,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

export enum AlertTypeEnum {
  Info = 'info',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}

@Component({
  selector: 'alert',
  imports: [IconComponent],
  templateUrl: 'alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnInit {
  //#region Host Bindings

  @HostBinding('attr.uicontrol')
  uiControl = '';

  //#endregion

  //#region Inputs/Outputs

  type = input<AlertTypeEnum>(AlertTypeEnum.Info);
  title = input<string>('');
  message = input<string>('');

  //#endregion

  //#region Properties

  protected icon?: IconType;

  //#endregion

  //#region Functions

  ngOnInit(): void {
    switch (this.type()) {
      case AlertTypeEnum.Success: {
        this.icon = ICONS.CHECK_CIRCLE;
        break;
      }
      case AlertTypeEnum.Warning: {
        this.icon = ICONS.WARNING;
        break;
      }
      case AlertTypeEnum.Error: {
        this.icon = ICONS.WARNING;
        break;
      }
      default: {
        this.icon = ICONS.INFO;
        break;
      }
    }
  }

  //#endregion
}
